import { Box, styled, Typography } from "@material-ui/core";
import { graphql } from "gatsby";
import React from "react";
import { formatMultilinesText } from "../../helpers/markdown";
import { ReferralInstructionsFragment as Props } from "./__generated__/ReferralInstructionsFragment";
import Imgix from "react-imgix";

const CustomImage = styled(Imgix)(() => ({
  width: "100%",
  maxWidth: "500px"
}));

export default function ReferralInstructionsSection({
  step1Title,
  step1Subtitle,
  step2Title,
  step2Subtitle,
  step2Image,
  step3Title,
  step3Image
}: Props) {
  return (
    <Box display="flex" flexDirection="column">
      {/* First row: Step1 */}
      <Box
        display="flex"
        justifyContent="center"
        marginBottom={{ xs: 6, sm: 4 }}
      >
        <Box flex={1}>
          <Box mb={{ xs: 2, sm: 3 }}>
            <Typography variant="h4" className="center white">
              - 1 -
            </Typography>
          </Box>

          <Typography
            variant="h5"
            dangerouslySetInnerHTML={{
              __html: formatMultilinesText(step1Title)
            }}
            className="white center"
          />

          <Box mt={{ xs: 3, sm: 2 }}>
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{
                __html: formatMultilinesText(step1Subtitle)
              }}
              className="center"
              color="textSecondary"
            />
          </Box>
        </Box>
      </Box>

      {/* Second row: Step2 + Step 3 */}
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems="stretch"
      >
        {/* Step 2 */}
        <Box
          display="flex"
          flexDirection={{ xs: "column-reverse", sm: "column" }}
          alignItems="center"
          justifyContent="space-between"
          flex={1}
          marginRight={{ xs: 0, sm: 5 }}
        >
          <CustomImage
            src={step2Image.url}
            width={500}
            imgixParams={{
              q: 75
            }}
          />

          <Box
            mt={{ xs: 2, sm: -6 }}
            mb={{ xs: -3, sm: 0 }}
            minHeight={{ xs: 0, sm: "210px" }}
          >
            <Box mb={{ xs: 2, sm: 3 }}>
              <Typography variant="h4" className="center white">
                - 2 -
              </Typography>
            </Box>

            <Typography
              variant="h5"
              color="textSecondary"
              dangerouslySetInnerHTML={{
                __html: formatMultilinesText(step2Title)
              }}
              className="white center"
            />

            {step2Subtitle && (
              <Box mt={{ xs: 3, sm: 2 }} minHeight={{ xs: "0px", sm: "0px" }}>
                <Typography
                  variant="body1"
                  dangerouslySetInnerHTML={{
                    __html: formatMultilinesText(step2Subtitle)
                  }}
                  className="center"
                  color="textSecondary"
                />
              </Box>
            )}
          </Box>
        </Box>

        {/* Step 3 */}
        <Box
          display="flex"
          flexDirection={{ xs: "column-reverse", sm: "column" }}
          alignItems="center"
          justifyContent="space-between"
          flex={1}
          marginLeft={{ xs: 0, sm: 5 }}
        >
          <CustomImage
            src={step3Image.url}
            imgixParams={{
              q: 75
            }}
          />

          <Box
            mt={{ xs: 2, sm: -6 }}
            mb={{ xs: -3, sm: 0 }}
            minHeight={{ xs: 0, sm: "210px" }}
          >
            <Box mb={{ xs: 2, sm: 3 }}>
              <Typography variant="h4" className="center white">
                - 3 -
              </Typography>
            </Box>

            <Box minHeight={{ xs: "0px", sm: "0px" }}>
              <Typography
                variant="h5"
                color="textSecondary"
                dangerouslySetInnerHTML={{
                  __html: formatMultilinesText(step3Title)
                }}
                className="white center"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export const ReferralInstructionsFragment = graphql`
  fragment ReferralInstructionsFragment on DatoCmsCModuleReferralInstructionsSection {
    step1Title
    step1Subtitle
    step2Title
    step2Subtitle
    step2Image {
      url
    }
    step3Title
    step3Image {
      url
    }
    container
    containerDisableGutters
    model {
      apiKey
    }
  }
`;
